exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1szdFMkekYdZrPjKitdsFl{position:fixed;left:0;bottom:0}\n", ""]);

// exports
exports.locals = {
	"caWidgetContainer": "_1szdFMkekYdZrPjKitdsFl"
};